export const FEATURE_NAME = '@zerops/zerops/feature/billing-info-edit-dialog';
